export enum FileUploadStatus {
  AwaitingInput,
  FileSelected,
  Submitting,
  Complete,
  Error
}
